import { createDuration } from './create';

export function clone () {
    return createDuration(this);
}




// WEBPACK FOOTER //
// ./node_modules/moment/src/lib/duration/clone.js